<template>
    <div id="form-container" ref="formContainer">
        <b-container fluid>
            <h1>
                Update Name
            </h1>
            <div>
                Any name change may take up to one month to be processed by MDH.
            </div>
            <b-form class="mt-3">
                <b-row>
                    <b-col cols="4">
                        <BaseTextInput v-model="profile.firstName"
                                       :v="$v.profile.firstName"
                                       slug="firstName"
                                       label="First Name"
                        />
                    </b-col>
                    <b-col cols="4">
                        <BaseTextInput v-model="profile.middleName"
                                       :v="$v.profile.middleName"
                                       slug="middleName"
                                       label="Middle Name"
                        />
                    </b-col>
                    <b-col cols="4">
                        <BaseTextInput v-model="profile.lastName"
                                       :v="$v.profile.lastName"
                                       slug="lastName"
                                       label="Last Name"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        You must upload a copy of the legal document pertaining to your name change i.e. court order, marriage document or divorce decree.
                        Please DO NOT submit your driver's license, state ID, or social security card.
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        Current attached file: <span>{{!attachment ? 'No file attached' : attachment.filename}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <FileAttachment v-on:attachment-added="addAttachment"
                                        :attachment-type-options="opts.attachmentOptions"
                                        describedBy="attachment"
                                        id="attachment"
                        />
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="2">
                        <b-button type="button" variant="primary" @click="showConfirmModal">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
            <b-modal id="confirm-modal" hide-header hide-footer>
                <h2>Confirm Name Change</h2>
                <hr/>
                <form ref="form" @submit.prevent="updateName">
                    You are requesting to change your name to {{profile.firstName}} {{profile.middleName + " "}}{{profile.lastName}}.
                    <p class="mt-2">Press Confirm to submit this name change request or Cancel to return to the request view.</p>
                    <div>
                        <b-button @click="closeConfirmModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary" :disabled="disableButton">Confirm</b-button>
                    </div>
                </form>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import { required} from 'vuelidate/lib/validators'
import {toastService} from "@/mixins/toastService"
import FileAttachment from "@/components/templates/input/FileAttachment"

axiosRetry(axios, { retries: 0,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    data: () => ({
       disableButton: false,
        profile: {},
        opts: {
            attachmentOptions: []
        },
        attachment: null
    }),
    components:{
        FileAttachment
    },
    validations() {
        return {
            profile: {
                firstName: { required },
                lastName: { required },
                middleName: { required: false },
                attachment: { required },
            }
        }
    },
    methods: {
        initialize() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/user`)
                .then(response => {
                    this.profile = response.data
                    this.profile.attachment = null
                })
        },
        loadAttachmentOptions(){
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/public/nameTypes`, {ignoreHeader: true})
                .then(response => {
                    for(let type of response.data){
                        this.opts.attachmentOptions.push({
                            value: type.code,
                            text: type.description
                        })
                    }
                })
        },
        addAttachment(value){
            this.profile.attachment = value
            this.attachment = value
            setTimeout( () => this.$emit('attachment-complete'), 10000);
        },
        updateName() {
            this.disableButton = true;
            this.$v.$touch()
            if (!this.$v.$invalid) {
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/change/name/`, this.profile)
                    .then(response => {
                        toastService.showRootToast("Name Update", "Your name change has been submitted.", "success", this.$root)
                    }) .catch(error => {
                        toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
                      this.disableButton = false;
                    }).finally(()=>{
                        this.closeConfirmModal();
                })
            }
            else{
              this.disableButton=false;
            }
        },
        showConfirmModal(){
            this.$bvModal.show('confirm-modal');
        },
        closeConfirmModal(){
            this.$bvModal.hide('confirm-modal');
        },
    },
    created() {
        this.initialize()
        this.loadAttachmentOptions()
        document.title = "Update Name - NAR"
    },
    mixins: [
        toastService
    ],
}
</script>